import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {IDataTableService} from '../common/interfaces/data-table-service.interface';
import {ITableColumn} from '../common/interfaces/table-column.interface';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs/operators';
import {ActivatedRoute} from '@angular/router';
import {SETTINGS_COLUMN} from '../../shared/components/table/table.component';
import {StorageService} from './storage.service';
import {UserTableSettingsService} from './user-table-settings.service';
import {Sort} from '@angular/material/sort';

const REGISTER_COLUMNS = 'REGISTER_COLUMNS';

@Injectable({
    providedIn: 'root'
})
export class RegisterDataTableService implements IDataTableService<any> {
    route = inject(ActivatedRoute);
    data$$: BehaviorSubject<any> = new BehaviorSubject({});
    data$: Observable<any> = this.data$$.asObservable();
    isLoaded = toSignal<boolean>(this.data$
        .pipe(map(v => 'values' in v)));
    isDataLoaded = toSignal(this.data$);

    showCustomColumns = true;

    private userTableSettingsService = inject(UserTableSettingsService);

    key: string = '';
    SORT_POSTFIX = '-sort';

    constructor(
        private storageService: StorageService,
    ) {
        this.key = this.route.snapshot.url[0].path + '-table';
    }

    getData(): any[] {
        return this.data$$.getValue();
    }

    getColumns(): ITableColumn[] {
        return [
            {
                name: 'isSelected',
                title: '',
                isRequired: true,
                settingTitle: 'Приоритет',
                useCustomTemplate: true,
            },
            {
                name: 'id',
                title: 'Id',
                isRequired: true,
                useCustomTemplate: false,
            },

            {
                name: 'rateGroup',
                title: 'Группа оценки',
                isRequired: true,
                useCustomTemplate: false,
            },
            {
                name: 'rateSubGroup',
                title: 'Подгруппа оценки',
                isRequired: true,
                useCustomTemplate: false,
            },
            {
                name: 'rateKind',
                title: 'Вид оценки',
                isRequired: true,
                useCustomTemplate: false,
            },
            {
                name: 'name',
                title: 'Название',
                useCustomTemplate: false,
            },
        ];
    }


    sorted(sort: Sort): { columnName: string, ascending: boolean | null } {
        return {
            columnName: sort.active,
            ascending: sort.direction === '' ? null : sort.direction === 'asc',
        };
    }


    getCustomColumns(): string[] {

        // const key = this.route.snapshot.url[0].path + '-table';
        const parsable = this.storageService.getItem(this.key);
        return parsable ? JSON.parse(parsable) : [...this.getColumns().map(col => {
            const res = col.default || col.isRequired ? col.name : null;
            return res;
        }).filter(v => v !== null), SETTINGS_COLUMN];
    }

    setCustomColumns(columnName: string[]): void {
        // const key = this.route.snapshot.url[0].path + '-table';
        this.storageService.setItem(this.key, JSON.stringify(columnName));
        // this.userTableSettingsService.setItem(key, JSON.stringify(columnName), this.sorted);
        this.updateUserData();
    }

    setData(data: {
        pager: any;
        values: {
            firm: string;
            facilityAddress: string;
            id: number;
            facility: string;
            createAt: string
        }[]
    }): void {
        this.data$$.next(data);
    }

    resetData(): void {
        this.data$$.next({});
    }

    saveSorting(event: Sort): void {
        console.log('sort RegisterDataTableService', event);
        this.storageService.setItem(this.key + this.SORT_POSTFIX, JSON.stringify(this.sorted(event)));
        this.updateUserData();
    }

    updateUserData(): void {
        // const key = this.route.snapshot.url[0].path + '-table';
        const tableData = this.storageService.getItem(this.key);
        const sortingData = this.storageService.getItem(this.key + this.SORT_POSTFIX);


        this.userTableSettingsService.setItem(this.key, JSON.parse(tableData || '[]'), JSON.parse(sortingData || '{}'));
    }

}
